import { PayloadAction } from '@reduxjs/toolkit';

import { GridConfigState } from 'editor/src/store/gridConfig/types';

const setRequestedCalendarCountriesReducer = (state: GridConfigState, action: PayloadAction<string[] | null>) => {
  state.requestedCalendarCountries = action.payload;
};

export default setRequestedCalendarCountriesReducer;
